<script lang="ts">
  import { type Snippet } from 'svelte';
  import { fade } from 'svelte/transition';
  
  type Props = {
    value: number | string;
    large?: boolean;
    class?: string;
    children: Snippet;
  }
  const props: Props = $props();

  let prevValue = $state<number | string>('');
  let direction = $state<number>(0);

  $effect(() => {
    if (prevValue !== props.value) {
      direction = prevValue < props.value ? 1 : -1;
      prevValue = props.value;
    }
  })
</script>

<div in:fade out:fade class={`pill ${props.class}`} class:large={props.large}>
  {#key props.value}
    <span>
      {props.value}
    </span>
  {/key}
  {@render props.children()}
</div>

<style lang="scss">
  @use 'sass:color';
  @use '~/theme/theme';
  @use '~/theme/include-media' as *;

  .pill {
    font-family: 'Fira Code', monospace;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 1em;
    padding: 0.25em 0.5em;
    font-weight: bold;
    font-size: 1rem;
    gap: 0.5em;
    @include media('>=desktop') {
      font-size: 1.25rem;
    }

    :global(svg) {
      font-size: 24px;
    }
  }

  .red {
    background-color: theme.$tile-red-light;
    border: 1px solid color.adjust(theme.$tile-red-light, $lightness: -20%);
    :global(html.dark-mode) & {
      background-color: theme.$tile-red-dark;
      border: none;
    }
  }

  .green {
    background-color: color.adjust(theme.$star-bonus, $lightness: 20%);
    border: 1px solid color.adjust(theme.$star-bonus);
    :global(html.dark-mode) & {
      background-color: color.adjust(theme.$star-bonus, $lightness: -10%);
      // background-color: theme.$tile-green-dark;
      border: none;
    }
  }
  .orange {
    background-color: theme.$tile-orange-light;
    border: 1px solid color.adjust(theme.$tile-orange-light, $lightness: -20%);
    :global(html.dark-mode) & {
      background-color: theme.$tile-orange-dark;
      border: none;
    }
  }
  .purple {
    background-color: theme.$tile-purple-light;
    border: 1px solid color.adjust(theme.$tile-purple-light, $lightness: -20%);
    :global(html.dark-mode) & {
      background-color: theme.$tile-purple-dark;
      border: none;
    }
  }
</style>
